import { ValidatorService } from '../../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
declare var $;

@Component({
  selector: 'app-select2-multi',
  templateUrl: './select2-multi.component.html',
  styleUrls: ['./select2-multi.component.scss']
})
export class Select2MultiComponent implements OnInit {

  @Input() public default: string = 'Placeholder default';
  @Input() public options: any[];
  @Input() public label: string;
  @Input() public key: string;
  @Input() public model: any = [];
  @Input() public element: string;
  @Input() public response: string;
  @Input() public disabled: boolean = false;

  @Output() public SelectCallback: EventEmitter<any> = new EventEmitter;

  private data: any[];

  constructor(private validatorService: ValidatorService) {
  }

  ngOnInit() {

    if (this.element) {
      // se debe renombrar el this global para poder utilizarlo en el setTimeOut
      let _this = this;

      // se debe colocar un timeout para que de tiempo de que se cargue el DOM
      setTimeout(function () {

        // iniciando input y recibiendo model
        _this.input().select2({
          'placeholder': _this.default,
          'multiple': true,
          'data': _this.getData()
        });

        // enviamos al padre nuestro valor si es que hay cambios dentro del componente
        _this.input().on('select2:select', function (e) {
          _this.emit();
        });

        _this.input().on('select2:unselect', function(e) {
          _this.emit();
        });

      }, 500);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.rebuild();
  }

  getData() {
    let _this = this;

    // se regresa un mensaje predeterminado si es que no existen registros
    if (!this.options || this.options.length <= 0) {
      this.data = [{
        id: -1,
        text: 'No existen registros'
      }]
      return this.data;
    }

    this.data = $.map(this.options, function (obj) {
      if(_this.model && _this.model.length > 0 && _this.model.indexOf(obj[_this.key].toString()) != -1) {
        obj.selected = true;
      } else {
        obj.selected = false;
      }

      obj.id = obj[_this.key];
      obj.text = obj[_this.label];

      return obj;
    });

    return this.data;
  }

  rebuild() {
    this.input().empty();
    this.input().select2({
      'placeholder': this.default,
      'multiple': true,
      'data': this.getData()
    });
  }

  // emite la respuest al callback
  emit() {
    this.SelectCallback.emit(this.value());
  }

  value() {
    return this.input().val();
  }

  input() {
    return $('#' + this.element);
  }

}


// WEBPACK FOOTER //
// ./src/app/components/tools/select2/select2-multi/select2-multi.component.ts